export enum AceOpportunityDeliveryModelEnum {
  SAAS_or_PAAS = 'SaaS or PaaS',
  BYOL_or_AMI = 'BYOL or AMI',
  MANAGED_SERVICES = 'Managed Services',
  PROFESSIONAL_SERVICES = 'Professional Services',
  RESELL = 'Resell',
  OTHER = 'Other',
}
